import { render, staticRenderFns } from "./ManagementSidebar.vue?vue&type=template&id=8c4f1cdc&"
import script from "./ManagementSidebar.vue?vue&type=script&lang=js&"
export * from "./ManagementSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports